import React, { useEffect, useRef, useState } from 'react'
import HeaderComponent from './HeaderComponent';
import { baseURL, token } from '../token';
import axios from 'axios';
import Logo from './Logo';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { handleUnAuthorized } from './hooks/handleUnAuthorized';

function ProfilePage() {
    const [Id, setId] = useState(null)
    const [profile, setProfile] = useState({})
    const [holder_name, setHolder_name] = useState();
    const [account_number, setAccount_number] = useState();
    const [ifsc_code, setIfsc_code] = useState();
    const [upi_id, setUpi_id] = useState();

    const [frontLoaded, setfrontLoaded] = useState(null)
    const [backLoaded, setbackLoaded] = useState(null)
    const [Name, setName1] = useState()
    const [name, setName] = useState()
    const [Email, setEmail] = useState()
    const [Number, setNumber] = useState()
    const [DOB, setDob] = useState()
    const [referral, setReferral] = useState('')
    const [enable, setEnable] = useState(true);
    const [message, setMessage] = useState('');
    const [isKycModalOpen, setIsKycModalOpen] = useState(false);
    const navigate = useNavigate();
    console.log('profile :>> ', profile);

    const fetchdata = () => {
        let access_token = localStorage.getItem("access_token")
        if (!access_token) {
            navigate('/LoginPage');
            return;
        }
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseURL + `/me`, { headers })
            .then((res) => {
                setProfile(res.data)
                setId(res.data._id);
                setName1(res.data.Name)
                setName(res.data.Name)
                setEmail(res.data.Email)
                setReferral(res.data.referral)
                setHolder_name(res.data.holder_name);
                setAccount_number(res.data.account_number);
                setIfsc_code(res.data.ifsc_code);
                setUpi_id(res.data.upi_id);
            }).catch((e) => {
                if (e.response?.status === 401) {
                    handleUnAuthorized(e.response.status, navigate)
                } else {
                    console.error('Error fetching profile:', e);
                }
            })
    }

    useEffect(() => {
        fetchdata();
    }, [])

    const handleEdit = async () => {
        setEnable(false)
    }

    const handleCancel = async () => {
        setEnable(true);
        setName(profile.Name); // Reset to original name
    }

    // edit name
    const handleSave = async () => {
        setMessage('');
        try {
            const reqbody = {
                Name: name
            }
            const accessToken = localStorage.getItem('access_token');
            if (!accessToken) {
                navigate('/LoginPage');
                return;
            }
            const headers = { Authorization: `Bearer ${accessToken}` };

            const responsedetail = await axios.patch(baseURL + '/user/edit', reqbody, {
                headers: headers,
            });
            if (responsedetail) {
                if (responsedetail?.data === 'User name already exist!') {
                    Swal.fire({
                        icon: "error",
                        title: responsedetail?.data,
                        confirmButtonText: "OK",
                    });
                    return
                }
                setEnable(true);
                setMessage("Name edited successfully.");
                setTimeout(() => setMessage(''), 2000);
                fetchdata(); // Refresh profile data
            }
        } catch (error) {
            console.log(error);
            if (error.response?.status === 401) {
                handleUnAuthorized(error.response.status, navigate)
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error updating name",
                    text: error.response?.data?.message || "Something went wrong",
                    confirmButtonText: "OK",
                });
            }
        }
    }

    const handleLogout = () => {
        let access_token = localStorage.getItem("access_token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.post(baseURL + `/logout`, {}, { headers }) // Fixed: removed extra headers object
            .then((res) => {
                localStorage.removeItem('access_token');
                localStorage.removeItem('access_token_expiration');
                navigate('/LoginPage');
                window.location.reload(true)
            }).catch((e) => {
                console.error('Logout error:', e);
                // Still clear local storage even if API fails
                localStorage.removeItem('access_token');
                localStorage.removeItem('access_token_expiration');
                navigate('/LoginPage');
                if (e.response?.status === 401) {
                    handleUnAuthorized(e.response.status, navigate)
                }
            })
    };

    let aadharProcess = useRef(false);

    const handleSubmitdata = (e) => {
        e.preventDefault(); // Added preventDefault to avoid form submission issues

        if (profile?.verified === "unverified") {
            if (aadharProcess.current === false) {
                aadharProcess.current = true;

                const formData = new FormData();

                let todayDate = new Date();
                let year = todayDate.getFullYear();
                let month = todayDate.getMonth() + 1;
                let day = todayDate.getDate();

                if (month < 10) {
                    month = "0" + month;
                }
                if (day < 10) {
                    day = "0" + day;
                }

                let formattedDate = year + "-" + month + "-" + day;

                formData.append("Name", Name);
                formData.append("Email", Email);
                formData.append("Number", Number);
                formData.append("DOB", formattedDate);
                formData.append("front", frontLoaded);
                formData.append("back", backLoaded);

                if (frontLoaded && backLoaded && Number) {
                    const access_token = localStorage.getItem('access_token')
                    if (!access_token) {
                        navigate('/LoginPage');
                        aadharProcess.current = false;
                        return;
                    }
                    const headers = {
                        Authorization: `Bearer ${access_token}`,
                    }

                    axios.post(baseURL + `/aadharcard`, formData, { headers })
                        .then((res) => {
                            if (res.data.msg === false) {
                                Swal.fire({
                                    title: "Duplicate Entity",
                                    icon: "error",
                                    confirmButtonText: "OK",
                                });
                                setName1('');
                                setEmail('');
                                setNumber('');
                                setDob('');
                                setfrontLoaded(null);
                                setbackLoaded(null);
                            }
                            else {
                                Swal.fire({
                                    title: "Your KYC form submitted",
                                    icon: "success",
                                    showConfirmButton: false,
                                    timer: 1200
                                });
                                setTimeout(() => {
                                    window.location.reload()
                                }, 1200)
                            }
                            aadharProcess.current = false;
                        }).catch((e) => {
                            aadharProcess.current = false;
                            if (e.response?.status === 401) {
                                handleUnAuthorized(e.response.status, navigate)
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: "Submission Failed",
                                    text: "Please try again later",
                                    confirmButtonText: "OK",
                                });
                            }
                        })
                }
                else {
                    aadharProcess.current = false;
                    Swal.fire({
                        icon: "warning",
                        title: "Incomplete Form",
                        text: "Please fill all fields and upload both Aadhar images",
                        confirmButtonText: "OK",
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "info",
                    title: "Request in Progress",
                    text: "You have already submitted a request.",
                    confirmButtonText: "OK",
                });
            }
        }
        else if (profile?.verified === "pending") {
            Swal.fire({
                icon: "info",
                title: "Request in Process",
                text: "Your KYC request is already being processed.",
                confirmButtonText: "OK",
            });
        }
        else {
            Swal.fire({
                icon: "info",
                title: "Already Verified",
                text: "Your KYC is already verified.",
                confirmButtonText: "OK",
            });
        }
    }

    useEffect(() => {
        let access_token = localStorage.getItem('access_token');
        if (!access_token) {
            navigate("/LoginPage");
        }
    }, [navigate])

    return (
        <>
            <section id="main-bg">
                <div id="profile-container" className="container mx-0">
                    <div className="row">
                        <div className="col-12">
                            <HeaderComponent userData={profile} />
                        </div>
                        <div className="col-12 card mt-3 walletcard pt-2 px-0 mx-auto ">
                            <div className="text-center">Profile</div>
                            <div className="card-body walletbody mt-2">
                                <div className="row p-1">
                                    <div className="col-12 d-flex justify-content-center">
                                        <div id="profile-img-bg" className="rounded-circle">
                                            <img src="./images/img.jpg" className="rounded-circle mw-100" alt="Profile" />
                                        </div>
                                    </div>
                                    <div className="col-12 my-2">
                                        <label htmlFor="name" className="text-left text-yellow">Name</label>
                                    </div>
                                    <div className="col-12 d-flex">
                                        <input
                                            style={{ textTransform: "capitalize" }}
                                            type="text"
                                            className="col-9 text-left d-flex details-1"
                                            defaultValue={profile?.Name}
                                            value={name}
                                            onChange={(e) => { setName(e.target.value) }}
                                            disabled={enable}
                                        />
                                        <div className="col-3 mx-1 d-flex justify-content-end">
                                            {enable ?
                                                (<button className="bg-black btn" onClick={handleEdit}>Edit</button>) :
                                                (<>
                                                    <div className='d-flex justify-content-center gap-2'>
                                                        <button className="bg-blue btn" onClick={handleCancel}>Cancel</button>
                                                        <button className="bg-red btn" onClick={handleSave}>Save</button>
                                                    </div>
                                                </>)
                                            }
                                        </div>
                                    </div>
                                    {message && <p className="text-success">{message}</p>}
                                    <div className="col-12 my-2">
                                        <label htmlFor="mobile number" className="text-left text-yellow">Mobile Number</label>
                                    </div>
                                    <div className="col-12 my-1">
                                        <input type="text" className="col-12 text-left d-flex details" value={profile?.Phone || ''} disabled />
                                    </div>

                                   
                                    <div className="col-12" style={{ display: 'block' }}>
                                        <div className="card container border border-success mt-2 kycbox">
                                            <div className="row align-items-center my-2">
                                                <div className=" my-auto col-6">
                                                    <p className="mb-0">KYC status </p>
                                                    <div className="d-flex">
                                                        <h6><strong><span className='text-error'>{profile?.verified?.charAt(0)?.toUpperCase() + profile?.verified?.slice(1) || 'N/A'}</span></strong></h6>
                                                        {profile?.verified === 'verified' && <span className="material-symbols-outlined text-success">done</span>}
                                                        {profile?.verified === 'unverified' && <span className="material-symbols-outlined text-error" style={{ color: 'red' }}>close</span>}
                                                        {profile?.verified === 'pending' && <span className="material-symbols-outlined text-warning" style={{ color: 'orange' }}>pending</span>}
                                                    </div>
                                                </div>
                                                <div className="col-6 d-flex justify-content-end">
                                                    {profile?.verified === 'unverified' &&
                                                        <button type="button" className="btn btn-success float-right" onClick={() => setIsKycModalOpen(true)}>
                                                            Add KYC
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        {/* Add KYC Modal */}
                                        {isKycModalOpen && (
                                            <div
                                                aria-hidden="true"
                                                onClick={() => setIsKycModalOpen(false)}
                                                style={{
                                                    position: 'fixed',
                                                    inset: 0,
                                                    background: 'rgba(0, 0, 0, 0.5)',
                                                    zIndex: 2000,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '12px',
                                                }}
                                            >
                                            <div
                                                role="dialog"
                                                aria-modal="true"
                                                aria-labelledby="exampleModalLabel"
                                                onClick={(e) => e.stopPropagation()}
                                                style={{
                                                    width: '100%',
                                                    maxWidth: '500px',
                                                    maxHeight: '90vh',
                                                    overflowY: 'auto',
                                                    background: '#fff',
                                                    borderRadius: '8px',
                                                    color: 'black',
                                                }}
                                            >
                                                    <div className="modal-header">
                                                        <h1 className="modal-title fs-5" id="exampleModalLabel">Add KYC Details</h1>
                                                        <button type="button" className="btn-close" onClick={() => setIsKycModalOpen(false)} aria-label="Close" />
                                                    </div>
                                                    <div className="modal-body">
                                                        <form onSubmit={handleSubmitdata}>
                                                            <div className='row p-2' style={{ marginTop: "10px" }}>
                                                                <div className="kyc-doc-input border col-12">
                                                                    <div className="label">Name</div>
                                                                    <input type="text"
                                                                        className='col-12'
                                                                        style={{ border: '1px solid black', padding: '5px', marginBottom: '5px' }}
                                                                        name="Name"
                                                                        placeholder='Enter name'
                                                                        value={Name || ''}
                                                                        disabled
                                                                        onChange={(e) => setName1(e.target.value)}
                                                                        required
                                                                    />
                                                                </div>

                                                                <div className="kyc-doc-input border col-12 mt-4">
                                                                    <div className="label">Email Id</div>
                                                                    <input type="email"
                                                                        className='col-12'
                                                                        style={{ border: '1px solid black', padding: '5px', marginBottom: '5px' }}
                                                                        name="Email"
                                                                        placeholder='Enter your email'
                                                                        value={Email || ''}
                                                                        onChange={(e) => setEmail(e.target.value)}
                                                                        required
                                                                    />
                                                                </div>

                                                                <div className="kyc-doc-input border col-12 mt-4">
                                                                    <div className="label">Aadhar Number</div>
                                                                    <input type="tel"
                                                                        className='col-12'
                                                                        style={{ border: '1px solid black', padding: '5px', marginBottom: '5px' }}
                                                                        name="AadharNumber"
                                                                        placeholder='Aadhar Number'
                                                                        value={Number || ''}
                                                                        onChange={(e) => setNumber(e.target.value)}
                                                                        required
                                                                    />
                                                                </div>

                                                                <div className={`mt-4 mb-3 kyc-doc-input border col-12 position-relative`}>
                                                                    <input
                                                                        id="frontPhoto"
                                                                        name="frontPhoto"
                                                                        type="file"
                                                                        accept="image/*"
                                                                        required
                                                                        onChange={(e) => setfrontLoaded(e.target.files?.[0] || null)}
                                                                    />
                                                                    {!frontLoaded && <div className="cxy flex-column position-absolute" style={{ pointerEvents: 'none' }}>
                                                                        <img src="/images/file-uploader-icon.png" width="17px" alt="" className="snip-img" />
                                                                        <div className={` mt-2`}>
                                                                            Upload front Photo of your Aadhar Card.
                                                                        </div>
                                                                    </div>}
                                                                    {frontLoaded && <div>
                                                                        <img src="/images/file-icon.png" width="26px" alt="" style={{ marginRight: '20px' }} />
                                                                        <div className="d-flex flex-column" style={{ width: '80%' }}>
                                                                            <div>{frontLoaded.name}</div>
                                                                            <div>{(frontLoaded.size / 1024 / 1024).toFixed(2)} MB</div>
                                                                        </div>
                                                                        <div className="image-block">
                                                                            <img src="/images/global-cross.png" width="10px" alt="" onClick={() => setfrontLoaded(null)} style={{ cursor: 'pointer' }} />
                                                                        </div>
                                                                    </div>}
                                                                </div>

                                                                <div className={`kyc-doc-input border col-12 mt-4 position-relative`}>
                                                                    <input
                                                                        id="backPhoto"
                                                                        name="backPhoto"
                                                                        type="file"
                                                                        accept="image/*"
                                                                        required
                                                                        onChange={(e) => setbackLoaded(e.target.files?.[0] || null)}
                                                                    />
                                                                    {!backLoaded && <div className="cxy flex-column position-absolute" style={{ pointerEvents: 'none' }}>
                                                                        <img src="/images/file-uploader-icon.png" width="17px" alt="" className="snip-img" />
                                                                        <div className={`mt-2`}>
                                                                            Upload back Photo of your Aadhar Card.
                                                                        </div>
                                                                    </div>}
                                                                    {backLoaded && <div>
                                                                        <img src="/images/file-icon.png" width="26px" alt="" style={{ marginRight: '20px' }} />
                                                                        <div className="d-flex flex-column" style={{ width: '80%' }}>
                                                                            <div>{backLoaded.name}</div>
                                                                            <div>{(backLoaded.size / 1024 / 1024).toFixed(2)} MB</div>
                                                                        </div>
                                                                        <div className="image-block">
                                                                            <img src="/images/global-cross.png" width="10px" alt="" onClick={() => setbackLoaded(null)} style={{ cursor: 'pointer' }} />
                                                                        </div>
                                                                    </div>}
                                                                </div>
                                                            </div>
                                                            <div style={{ paddingBottom: "5%" }} />
                                                            <div className="refer-footer p-0">
                                                                <button type="submit" className="w-100 btn-success bg-success" style={{
                                                                    border: 'none',
                                                                    borderRadius: '5px',
                                                                    fontSize: '1em',
                                                                    fontWeight: '700',
                                                                    height: '48px',
                                                                    color: '#fff',
                                                                    textTransform: 'uppercase',
                                                                }}>
                                                                    Submit
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 card mt-3 walletcard pt-2 px-0 mx-auto text-black">
                            <div className="text-center">Metrics</div>
                            <div className="card-body walletbody mt-2">
                                <div className="col-12">
                                    <div className="row mt-2 p-1">
                                        <div className="col-6 p-1">
                                            <div className="card profile-category text-black text-center px-0">
                                                <p className="mt-2">Winning amount</p>
                                                <div className="card-body profilecard text-center align-items-center justify-content-center">
                                                    <h5>{profile?.withdrawAmount?.toFixed(2) || '0.00'}</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6 p-1">
                                            <div className="card profile-category text-white text-center px-0">
                                                <p className="mt-2">Wallet balance</p>
                                                <div className="card-body profilecard text-center align-items-center justify-content-center">
                                                    <h5>{profile?.Wallet_balance?.toFixed(2) || '0.00'}</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6 p-1">
                                            <div className="card profile-category text-white text-center px-0">
                                                <p className="mt-2">Bonus</p>
                                                <div className="card-body profilecard text-center align-items-center justify-content-center">
                                                    <h5>{profile?.totalBonus?.toFixed(2) || '0.00'}</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6 p-1">
                                            <div className="card profile-category text-white text-center px-0">
                                                <p className="mt-2">Penalty</p>
                                                <div className="card-body profilecard text-center align-items-center justify-content-center">
                                                    <h5>{profile?.totalPenalty?.toFixed(2) || '0.00'}</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6 p-1">
                                            <div className="card profile-category text-white text-center px-0">
                                                <p className="mt-2">Referral Earning</p>
                                                <div className="card-body profilecard text-center align-items-center justify-content-center">
                                                    <h5>{profile?.referral_earning?.toFixed(2) || '0.00'}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <div className="text-center my-2 row mt-2 mx-auto">
                                        <button className="col-12 btn rounded btn-danger px-2" onClick={handleLogout}>Logout</button>
                                    </div>
                <div className="" style={{ position: 'fixed', top: '50%', left: 'calc(100% - 40%)', transform: `translate(-50%,-50%)`, zIndex: 5 }}>
                    <div className="rcBanner flex-center">
                        <Logo />
                    </div>
                </div>
            </section>
        </>
    )
}

export default ProfilePage;